module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Intro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "para_1"
  }, [_vm._v("The Blue Ridge Mountains, which once served as a physical barrier between North Carolina and the great unknown, now beckon visitors from all over the world. Running along the ridge of the Blue Ridge Mountains, the Blue Ridge Parkway appears to hold the mountains together like a ribbon on a precious package.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A wide range of plants and wildlife inhabits the mountains, some of which are found nowhere else on earth. These mountains are sprinkled with some of the most rugged gorges, beautiful waterfalls, and highest peaks in the Eastern United States. National forests cover more than a million acres in the region.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The parkway was a gift that the greatest generation gave to the people of the United States. Although it displaced families, subsequent generations have enjoyed the peace and quiet, solitude, and beautiful vistas provided by the road and its right-of-way, which are maintained by the National Park Service. Begun in 1935, the majority of the construction work was done by private companies under federal contract; however, members of several Civilian Conservation Corps camps did much landscaping and cleanup.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The topography of Western North Carolina provides a healthy habitat for many plants and animals. The climate offers lowlanders a respite from summer heat and snow skiers frostbite warnings in the winter. Such extremes in weather conditions have produced a rugged native population that is a mixture of Eastern Band Cherokee Indians, whose ancestors lived in harmony with nature for centuries, and the descendants of Scots-Irish settlers of the 18th century.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Appalachian and Blue Ridge Mountains of North Carolina can be divided by subranges and other natural divisions. For this book, the 23 counties in the western part of the state have been divided into seven chapters.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "remove",
    attrs: {
      "href": "#/Chapter1#C1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("first chapter")]), _vm._v(" focuses on the northwestern corner of the state, which has adopted the name “High Country.” This section is home to a number of ski resorts and such iconic attractions as Grandfather Mountain and Mount Mitchell. The Black Mountains, which get their name from the dark green spruce and fir that give them a dark look from a distance, provide the highest elevations in this section of the Blue Ridge Mountains.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The region of the Blue Ridge Mountains south of Mount Mitchell adopted the label “Land of the Sky” early in the 20th century and is the focus of the "), _c('span', {
    staticClass: "remove",
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("second chapter")]), _vm._v(". Asheville is the crown jewel of the area.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('span', {
    staticClass: "remove",
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("third chapter")]), _vm._v(" of this book looks at the Great Balsams and Plott Balsams, two subranges of the Blue Ridge Mountains. The Great Balsams range is named for the spruce and fir trees found there. The Blue Ridge Parkway reaches its highest elevation at Richland Balsam in the Great Balsams. The Blue Ridge Parkway ends (or begins, if one is traveling north) at Soco Gap in the Plott Balsams.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Great Smoky Mountains National Park and the Qualla Boundary are the focus of the "), _c('span', {
    staticClass: "remove",
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fifth chapter")]), _vm._v(". Although Great Smoky Mountains National Park straddles the North Carolina-Tennessee state line, the entire park is included in this book. The Qualla Boundary is the home of the Eastern Band Cherokee Indians. It is not a reservation. It is land held in trust by the federal government. The Cherokee people have made these mountains their home since ancient times, and their language has played heavily in the naming of places in the western part of the state.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("A movement to establish a national park in the Great Smoky Mountains took hold in the 1920s but creating the park was not simple. Its 800 square miles or 507,869 acres lie in North Carolina and Tennessee and consist of 6,600 private tracts of land.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Both those states and private citizens donated millions of dollars to create Great Smoky Mountains National Park. It was the first national park given to the US government by the people. It seems appropriate, therefore, that it is the most visited national park in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Great Smoky Mountains are called “smoky” due to the fog that rises from the valleys and mountainsides. The range is home to the largest stand of old-growth trees in the Eastern United States.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Like the higher elevations of the Black Mountains, nearly all Great Smoky Mountains National Park’s mature Fraser fir trees have fallen victim to the balsam woolly adelgid.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After numerous skirmishes with European settlers in the late 1700s and early 1800s, in 1838, Pres. Andrew Jackson signed the Removal Act, which mandated the forced removal of the Cherokee people from the mountains of North Carolina to the Oklahoma Territory. This forced march is called the Trail of Tears due to the thousands of Cherokee who died on that journey. This was done in spite of the fact that the Cherokee people had a written constitution, a bilingual newspaper, and a number of Christian churches in which they sang hymns in their native language. A remnant of the Cherokee people stayed behind and hid in the mountains. Today, thousands of their descendants live on the Qualla Boundary.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("The Snowbird Mountains and southwestern corner of North Carolina are featured in ")]), _c('span', {
    staticClass: "remove",
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter five")]), _vm._v(" of this book. The least well-known section of the mountains in the state includes the Nantahala National Forest and Fontana Dam. The area attracts hikers and whitewater enthusiasts.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Nantahala National Forest covers 500,000 acres. “Nantahala” is Cherokee for “land of the noonday sun.” Due to the gorges and steep valleys in these mountains, the sun only hits the bottom of some of the valleys in the middle of the day. This is a rugged area. Elevation in the forest ranges from 1,200 to 5,800 feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Joyce Kilmer-Slickrock Wilderness contains 13,000 acres in the Snowbirds area. The Joyce Kilmer Memorial Forest was named for Kilmer, a 165th Infantry, Rainbow Division, soldier and poet who was born in New Brunswick, New Jersey, in 1886 and was killed in action in France on June 30, 1918. This old-growth forest consists of more than 100 species of trees. Some of the largest of the trees are hemlocks, red oaks, and poplars.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The "), _c('span', {
    staticClass: "remove",
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sixth chapter")]), _vm._v(" of this book takes a look at the “Land of Waterfalls.” Although waterfalls are found throughout the mountains of North Carolina, some of the most famous of them are located in this southern section that stretches from Macon County to Polk County.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The gradual drop in elevation in the Blue Ridge Mountains gives way to a region of lesser mountains and rolling hills that offer a transition into the Piedmont section of North Carolina. That area is called the foothills and is the focus of the "), _c('span', {
    staticClass: "remove",
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("last chapter")]), _vm._v(" in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some chapter divisions are more distinct than others. Due to elevation differences, several counties were divided between two chapters.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7537d72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 78
// module chunks = 0